import * as React from 'react';
export const kbcSvg = React.forwardRef(function kbcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0098CB',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M30.45 15.95h-29v-2.1s4.07-.78 9.53-1.33a6.86 6.86 0 0 0 8.83-.66c5.67-.29 10.64-.26 10.64-.26v4.35z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M15.13 3.87a4.35 4.35 0 1 1 0 8.7 4.35 4.35 0 0 1 0-8.7z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#003768',
        d: 'M15.17 21.25h1.54c.6 0 .83-.26.83-.66 0-.46-.23-.7-.78-.7h-1.59v1.36zm0 2.6h1.62c.6 0 .8-.27.8-.67s-.2-.69-.8-.69h-1.62v1.37zm-3.57-5.57h6.43c1.67 0 2.21.7 2.21 1.76 0 1.2-1 1.71-2.05 1.77v.02c1.07.09 2.11.22 2.11 1.63 0 .92-.55 1.82-2.38 1.82H11.6v-7zM30.45 25c-.8.24-1.87.39-2.82.39-3.39 0-5.88-.95-5.88-3.7 0-2.48 2.41-3.55 5.71-3.55.91 0 2.08.1 2.99.38v2.4a4.22 4.22 0 0 0-2.32-.65c-1.25 0-2.51.6-2.51 1.5 0 .87 1.25 1.48 2.51 1.48.95 0 1.64-.26 2.32-.64V25zm-25.9-2.34v2.63h-3.1v-7h3.1v3.15h.02l1.82-3.15h3.72L7.4 21.9l2.57 3.38H6.4l-1.84-2.63h-.02z',
      }),
    ),
  );
});
kbcSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var kbc = {
  category: 'brand',
  colorable: false,
  name: 'kbc',
  svg: kbcSvg,
};
